import React, {useEffect} from 'react';
import {Field} from 'redux-form';
import {useSelector} from "react-redux";
import JSONPretty from "react-json-pretty";

const Imp547 = () => {
    const formState = useSelector(state => state.form.wizard.values);
    const {hospitalFeatures} = useSelector(state => state.main);
    return (
        <div className="col-lg-12">
            <JSONPretty data={hospitalFeatures} />
            <JSONPretty data={formState} />
        </div>
    );
};

export default Imp547;